import { handleRouterReport } from '@/libs/app/report/router';
import { setRouteTrack, addMonitor, removeMonitor } from './util';

export default class RouteTrack {
  eventName = 'onpagehide' in window ? 'pagehide' : 'beforeunload';
  enterTime = 0;
  name = '';
  path = '';

  constructor(route) {
    this.init(route)
    this.load()
  }

  init(route) {
    this.enterTime = new Date().getTime()
    this.name = route.name
    this.path = route.path
    setRouteTrack(this.name, this.path)
    this.addEventListener()
  }

  // eslint-disable-next-line class-methods-use-this
  load() {
    handleRouterReport(1, 0);
  }

  addEventListener() {
    addMonitor(window, this.eventName, this.unload)
    addMonitor(document, 'visibilitychange', this.handleVisibilityChange)
  }

  handleVisibilityChange = () => {
    const now = new Date().getTime()
    if (document.hidden) {
      handleRouterReport(2, now - this.enterTime);
    } else {
      this.enterTime = now
      setRouteTrack(this.name, this.path)
      this.load()
      this.addEventListener()
    }
  }

  // eslint-disable-next-line class-methods-use-this
  unload = () => {
    const now = new Date().getTime()
    handleRouterReport(2, now - this.enterTime);
    removeMonitor(window, this.eventName, this.unload)
    removeMonitor(document, 'visibilitychange', this.handleVisibilityChange)
  }
}
